import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';

// Public invoice & payment page — intentionally NO AuthGuard/GuestGuard.
// The unguessable payment-link UUID in the URL is the access capability.
const PublicPayPage = Loadable(lazy(() => import('pages/pay')));

// ==============================|| PUBLIC PAYMENT ROUTING ||============================== //

const PayRoutes = {
  path: '/pay/:linkId',
  element: <PublicPayPage />
};

export default PayRoutes;
